// extracted by mini-css-extract-plugin
export default {"hot-video":"hot-video--SkaYI","left-icon":"left-icon--iCIEl","right-icon":"right-icon--mgiDt","title":"title--ZKrxt","total":"total--fPuNi","brand-scroll":"brand-scroll--i8DEk"};